import Disclaimer from "../components/Disclaimer";
import { BloodworkBadge } from "../components/Badges";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";

export default function Bloodwork() {
  return (
    <div data-testid="bloodwork-page">
      <SEO
        title="Bloodwork & Peptide Therapy Testing Requirements"
        description="Understand bloodwork categories used across peptide therapy — baseline required, recent recommended, or provider-determined. Your provider decides what testing is right for you."
        path="/bloodwork"
        breadcrumbs={[{ name: "Bloodwork", path: "/bloodwork" }]}
      />
      <section className="vv-hero">
        <div className="vv-container py-16">
          <Breadcrumbs items={[{ name: "Bloodwork", path: "/bloodwork" }]} />
          <div className="vv-hero-eyebrow mb-2">Bloodwork</div>
          <h1 className="font-display text-4xl md:text-5xl">Labs guide provider decisions.</h1>
          <p className="mt-4 text-stone-600 max-w-2xl">Some therapies benefit from baseline testing. Others can be reviewed with recent labs. Your provider decides what is needed for you.</p>
        </div>
      </section>
      <section className="vv-container py-14 grid md:grid-cols-3 gap-6">
        {[
          { level: "baseline_required", title: "Baseline Labs Generally Required", text: "For therapies with meaningful metabolic, hormonal, or organ-system effects, a provider typically wants recent baseline labs before considering treatment." },
          { level: "recent_recommended", title: "Recent Labs Recommended", text: "Recent labs help but the provider may proceed based on clinical judgment and history." },
          { level: "provider_determines", title: "Provider Determines Testing", text: "The provider decides what testing is appropriate based on your goals and history." },
        ].map((b) => (
          <div key={b.level} className="vv-card p-6">
            <BloodworkBadge level={b.level} />
            <div className="font-display text-xl mt-3">{b.title}</div>
            <p className="text-sm text-stone-600 mt-2 leading-relaxed">{b.text}</p>
          </div>
        ))}
      </section>
      <div className="vv-container pb-16"><Disclaimer /></div>
    </div>
  );
}
